import { Info } from 'lucide-react'
import type { CaptacaoTabView } from '@/components/Dashboard/captacaoTab.utils'
import { formatDashboardNumber } from '@/utils/crmValuesDisplay'

type Props = {
  view: CaptacaoTabView
  valuesVisible?: boolean
}

export function CaptacaoContextBanner({ view, valuesVisible = false }: Props) {
  return (
    <div
      className='flex gap-3 rounded-2xl border border-sky-200/80 bg-sky-50/80 px-4 py-3 dark:border-sky-900/50 dark:bg-sky-950/20'
      role='status'
    >
      <Info size={18} className='mt-0.5 shrink-0 text-sky-600 dark:text-sky-400' aria-hidden />
      <div className='min-w-0 text-sm'>
        <p className='font-medium text-text-primary'>Base ativa, sem entrada nova no período</p>
        <p className='mt-1 text-text-muted'>
          {formatDashboardNumber(view.activeLeads, valuesVisible)} leads na carteira closer — nenhum
          criado neste intervalo. Amplie para “Último trimestre” ou “Este ano” para ver entradas.
        </p>
      </div>
    </div>
  )
}
